import React, {useMemo} from "react";

import Logo from "../../assets/logo.svg";
import Dao from '../../assets/DAO.svg';
import Roobee from '../../assets/roobee.svg';
import NavigationLink from "../Interface/NavigationLink/NavigationLink";
import './style.scss'
import useResize from "../../hooks/useResize";
import Account from "../Account/Account";

function Navigation({routes, activeUrl, active}) {

    const { windowWidth } = useResize();
    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <div className={ active ? "navigation navigation-active" : "navigation"}>
            { mobileView ?
                <>
                    <div className="navigation-logo">
                        <img src={Roobee} alt="logo"/>
                        <img src={Dao} alt="logo"/>
                    </div>
                    <div className="navigation-account">
                        <Account className="some" />
                    </div>
                </>
                    :
                <div className="navigation-logo">
                    <img src={Logo} alt="logo"/>
                </div>
            }
            <div className="navigation-items">
                {routes.filter(route => route.name).map(route => (
                    <NavigationLink key={route.url} route={route} isActive={route.url === activeUrl}/>
                ))}
            </div>
        </div>
    );
}

export default Navigation;
